export function formatMoney(amount: number): string {
	try {
		return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(amount ?? 0);
	} catch {
		return `$${(amount ?? 0).toFixed(2)}`;
	}
}

export function formatDate(iso: string | null | undefined): string {
	if (!iso) return '';
	try {
		const d = new Date(iso);
		if (Number.isNaN(d.getTime())) return String(iso);
		return d.toLocaleDateString();
	} catch {
		return String(iso);
	}
} 